export const CHAMELEON_FAST_URL = 'https://fast.chameleon.io/'
export const ACCEPTED_L1_LOCATIONS = [9003, 9004, 9006]
